import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would connect to a backend
    alert("Thank you for your message. We will get back to you soon!");
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact">
      {/* Contact Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title animate-fade-up">Contact Us</h1>
          <p className="page-subtitle animate-fade-up">
            Get in touch with our team
          </p>
        </div>
        <div className="hero-overlay"></div>
        <div
          className="hero-image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80')",
          }}
        ></div>
      </section>

      <section className="contact-content section-padding">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info animate-fade-left">
              <h2>Get in Touch</h2>
              <p>
                Have questions about our manufacturing process or interested in
                collaboration? Reach out to us through any of the channels
                below.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h4>Our Headquarters</h4>
                    <p>123 Fashion District</p>
                    <p>New York, NY 10001</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email Us</h4>
                    <p>info@laigerclothing.com</p>
                    <p>manufacturing@laigerclothing.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+1 (555) 123-4567</p>
                    <p>Mon-Fri, 9AM-6PM EST</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <h4>Follow Our Journey</h4>
                <div className="social-icons">
                  <a href="#" className="social-icon">
                    📘
                  </a>
                  <a href="#" className="social-icon">
                    📷
                  </a>
                  <a href="#" className="social-icon">
                    💼
                  </a>
                  <a href="#" className="social-icon">
                    🎬
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form animate-fade-right">
              <h2>Send a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What is this regarding?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your project or inquiry..."
                    rows="5"
                  ></textarea>
                </div>

                <button type="submit" className="btn-primary">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h3>Visit Our Showroom</h3>
          <div className="map-placeholder">
            <div className="map-overlay">
              <p>📍 123 Fashion District, New York, NY 10001</p>
              <p>Showroom Hours: Mon-Fri 10AM-6PM, Sat 11AM-4PM</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
